<template>
  <div class="app-container">
    <WebHeader />
    <HomeCarousel/>
    <ProductSection id="product_sec"/>
    <AboutUs id="about_us"/>
    <WebFooter />
  </div>
</template>

<script>
import WebHeader from '../../components/common/WebHeader.vue'
import HomeCarousel from '../../components/homePage/homeCarousel.vue'
import ProductSection from '../../components/homePage/productSection.vue'
import AboutUs from '../../components/homePage/aboutUs.vue'
import WebFooter from '../../components/common/WebFooter.vue'

export default {
  name: 'App',
  components: {
    WebHeader,
    HomeCarousel,
    ProductSection,
    AboutUs,
    WebFooter
  }
}
</script>

<style scoped>

</style>
